(() => {
 'use strict';
 if (customElements.get('rydar-road-journey')) return;
 class RydarRoadJourney extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const options = { signal: this.controller.signal };
   this.track = this.querySelector('[data-track]');
   this.stage = this.querySelector('[data-stage]');
   this.panels = [...this.querySelectorAll('[data-panel]')];
   this.scenes = [...this.querySelectorAll('[data-scene]')];
   this.buttons = [...this.querySelectorAll('[data-state]')];
   this.counter = this.querySelector('[data-counter]');
   this.progress = this.querySelector('[data-progress]');
   this.announcement = this.querySelector('[data-announcement]');
   this.labels = ['Connected','Speed Camera','Road Traffic','Speed Limit','RoadPatrol / RYDAR'];
   this.colours = ['#32d639','#2783e2','#f21128','#bd3bf1','#f5f5f2'];
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.active = -1;
   this.frame = 0;
   this.header = document.querySelector('.section-header');
   this.buttons.forEach((button,index) => button.addEventListener('click', () => this.go(index), options));
   this.querySelector('[data-replay]').addEventListener('click', () => this.go(0), options);
   window.addEventListener('scroll', () => this.schedule(), { ...options, passive:true });
   window.addEventListener('resize', () => this.measure(), options);
   window.addEventListener('pageshow', () => this.measure(), options);
   if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', event => {
     if (event.target.contains(this)) this.go(0);
    }, options);
   }
   this.resizeObserver = new ResizeObserver(() => this.measure());
   if (this.header) this.resizeObserver.observe(this.header);
   this.setAttribute('data-enhanced','');
   this.measure();
  }
  disconnectedCallback() {
   if (!this.controller) return;
   this.controller.abort();
   this.resizeObserver.disconnect();
   cancelAnimationFrame(this.frame);
   this.controller = null;
   this.frame = 0;
  }
  measure() {
   const gap = Number(this.dataset.headerGap) || 0;
   const headerHeight = this.dataset.respectHeader === 'true' && this.header ? this.header.offsetHeight : 0;
   const available = window.innerHeight - headerHeight - gap - 12;
   const desiredHeight = Number(this.dataset.height) || 600;
   const mobile = window.innerWidth < 750;
   const minimumHeight = mobile ? (window.innerWidth - 26) * .4 + 440 : 480;
   this.compact = Math.min(desiredHeight,available) < minimumHeight;
   this.toggleAttribute('data-compact', this.compact);
   this.top = headerHeight + gap;
   this.step = Math.max(400, window.innerHeight * (Number(this.dataset.pace) || 90) / 100);
   this.style.setProperty('--rydar-height', Math.min(desiredHeight, Math.max(480,available)) + 'px');
   this.style.setProperty('--rydar-top', this.top + 'px');
   this.style.setProperty('--rydar-step', this.step + 'px');
   if (this.compact) this.render(Math.max(0,this.active),true); else { this.render(Math.max(0,this.active),true); this.update(); }
  }
  start() { return this.track.getBoundingClientRect().top + window.scrollY - this.top; }
  schedule() { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); }
  update() {
   if (this.compact) return;
   const distance = window.scrollY - this.start();
   this.render(Math.max(0,Math.min(4,Math.floor(distance / this.step))));
   this.progress.style.width = Math.max(0,Math.min(100,distance/(4.8*this.step)*100)) + '%';
  }
  render(index,force = false) {
   if (index === this.active && !force) return;
   this.active = index;
   this.setAttribute('data-current-state',String(index));
   this.style.setProperty('--rydar-accent',this.colours[index]);
   this.panels.forEach((panel,i) => { panel.hidden = i !== index && !(this.compact && i === 4); panel.classList.toggle('is-active',i === index); });
   this.scenes.forEach((scene,i) => { const shown = i === Math.min(index,3); scene.classList.toggle('is-active',shown); scene.setAttribute('aria-hidden',String(!shown)); });
   this.buttons.forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));
   this.counter.textContent = index === 4 ? 'RoadPatrol / RYDAR' : String(index+1).padStart(2,'0')+' / 04 · Scroll to explore';
   this.announcement.textContent = this.labels[index];
   if (this.compact) this.progress.style.width = ((index+1)/5*100)+'%';
  }
  go(index) {
   if (this.compact) { this.render(index); return; }
   window.scrollTo({ top: this.start() + (index + .18)*this.step, behavior: this.motion.matches ? 'instant' : 'smooth' });
  }
 }
 customElements.define('rydar-road-journey',RydarRoadJourney);
})();
